/* pdp-cro 2026-10-15 — PDP quote strip + Egg White line rating, from the static review cache
   (assets/data-yotpo.json — there is no live Yotpo call). No cart code here. */
(function () {
  var strip = document.querySelector('[data-mncro-quotes]');
  var lineEl = document.querySelector('[data-mncro-linerating]');
  if (!strip && !lineEl) return;
  var src = (strip || lineEl).getAttribute('data-src');
  if (!src) return;
  var esc = function (s) { return String(s || '').replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
  /* belt and braces: the file already flags these "nf"; never feature a health/weight claim */
  var CLAIM = /glucose|diabet|spike|glycemic|blood ?sugar|insulin|a1c|weight|pounds|\blbs?\b|\blose\b|ozempic|wegovy|mounjaro|glp|disease|celiac|pcos|doctor|minute/i;
  var NAMES = { 'ew-spaghetti': 'Egg White Spaghetti', 'ew-angelhair': 'Egg White Angel Hair' };
  var lineKeys = function (Y) { return Object.keys(Y).filter(function (k) { return k.indexOf('ew-') === 0 && Y[k] && Y[k].dist; }); };
  fetch(src).then(function (r) { return r.json(); }).then(function (Y) {
    /* 1. Egg White line rating — products with no reviews of their own (Spicy Beef Ramen) */
    if (lineEl) {
      var n = 0, sum = 0;
      lineKeys(Y).forEach(function (k) { var d = Y[k].dist; for (var s in d) { n += d[s]; sum += d[s] * (+s); } });
      if (n) lineEl.innerHTML = '<span class="stars" aria-hidden="true">★</span> ' + (sum / n).toFixed(1) +
        ' across our Egg White line <span aria-hidden="true">&middot;</span> ' + n.toLocaleString() + ' reviews';
    }
    /* 2. quote strip */
    if (!strip) return;
    var slug = strip.getAttribute('data-slug'), fam = strip.getAttribute('data-fam');
    var own = !!(Y[slug] && Y[slug].reviews), pool = [];
    if (own) pool = Y[slug].reviews.map(function (r) { return { r: r, k: slug }; });
    else if (fam === 'egg') lineKeys(Y).forEach(function (k) { (Y[k].reviews || []).forEach(function (r) { pool.push({ r: r, k: k }); }); });
    var seen = {}, pick = [];
    pool.forEach(function (e) {
      var r = e.r, t = r.t || '', len = t.length;
      if (pick.length >= 3 || r.nf || Math.round(r.s || 0) !== 5 || len < 40 || len > 170 || CLAIM.test(t + ' ' + (r.ti || ''))) return;
      var nm = (r.n || '').toLowerCase(); if (!nm || seen[nm]) return; seen[nm] = 1; pick.push(e);
    });
    if (pick.length < 2) return;
    var site = Y._site && Y._site.total, head = '';
    if (site >= 1000) head = '<span class="stars" aria-hidden="true">★★★★★</span>' + (Math.floor(site / 1000) * 1000).toLocaleString() + '+ reviews across Miracle Noodle';
    if (!own) head += (head ? ' <span aria-hidden="true">&middot;</span> ' : '') + 'from our Egg White line';
    strip.innerHTML = (head ? '<p class="mncro-quotes__count">' + head + '</p>' : '') +
      '<div class="mncro-quotes__list" role="list">' + pick.map(function (e) {
        return '<figure class="mncro-q" role="listitem"><blockquote>&ldquo;' + esc(e.r.t) + '&rdquo;</blockquote><figcaption>' + esc(e.r.n) +
          (own ? ', verified buyer' : ' &middot; ' + esc(NAMES[e.k] || 'Egg White line')) + '</figcaption></figure>';
      }).join('') + '</div>' + (own && document.getElementById('reviews') ? '<a class="mncro-quotes__more" href="#reviews">Read all reviews</a>' : '');
    strip.hidden = false;
  }).catch(function () {});
})();
